export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref6595.440d0bf1.jpg";